<template>
    <div v-if="dateList.length !== 0" class="action-carousel">
        <h5>{{ carousel.title }}</h5>
        <div v-if="dateList.length !== 1">
            <button type="button" @click="prevSlide" :disabled="carousel.currentCarousel === 0">
                <mdicon name="chevron-left" :size="30"/>
            </button>
            <button type="button" @click="nextSlide" :disabled="carousel.currentCarousel === dateList.length - 1">
                <mdicon name="chevron-right" :size="30"/>
            </button>
        </div>
    </div>
    <Splide
        ref="date_splide"
        :options="carousel.options"
        @splide:move="onSplideMove"
    >
        <SplideSlide v-for="(dateItem, dateKey) in dateList" :key="dateKey" class="list-carousel" :class="{
            'mobile-resize': dateList.length > 0 && dateList[carousel.currentCarousel]?.length !== carousel.chunk 
        }">
            <label v-for="(item, key) in dateItem" :key="key"
                :class="{
                    'item-carousel': true,
                    'active-carousel': item.date === date, 
                    'outlet-carousel': item.outlet, 
                    'loading-carousel': isLoadingTime
                }"
            >
                <input type="radio" v-model="selectDate" hidden :value="item.date"/>
                <div class="item-title">
                    <span class="item-title-week">{{ item.dayWeek }}</span> 
                    <span class="item-title-day">{{ item.day }}</span>
                </div>
            </label>
        </SplideSlide>
    </Splide>
</template>

<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import { addDays, format } from 'date-fns';
import { dateConfig } from '@/components/Calendar/configList';

import '@splidejs/vue-splide/css';

export default {
    name: 'CalendarDateList',
    props: ['date', 'branch'],
    components: {
        Splide,
        SplideSlide
    },
    watch: {
        selectDate(newSelectDate) {
            this.$emit('update:date', newSelectDate);
        },
        branch() {
            this.getDateList();
        },
        windowWidth(newWindowWidth) { // chunk by screen size
            if (newWindowWidth < 430) {
                this.carousel.chunk = 4;
            } else if (newWindowWidth < 576) {
                this.carousel.chunk = 5;
            } else if (newWindowWidth < 1200) {
                this.carousel.chunk = 7;
            } else {
                this.carousel.chunk = 7;
            }
            this.getDateList();
        }
    },
    data: () => {
        return {
            selectDate: '',
            dateList: [],
            carousel: {
                title: '',
                chunk: '',
                currentCarousel: 0,
                options: {
                    type: 'slide',
                    perPage: 1,
                    rewind: false,
                    drag: true,
                    start: 0,
                    arrows: false,
                    pagination: false
                }
            },
            windowWidth: '',
            isLoadingTime: false
        }
    },
    methods: {
        onResize () {
            this.windowWidth = window.innerWidth
        },
        getMonthTitle() {
            if (this.dateList[this.carousel.currentCarousel]) {
                const obj = this.dateList[this.carousel.currentCarousel].reduce(function (stack, value) {
                    return stack[value.month] ? stack[value.month]++ : stack[value.month] = 1, stack;
                }, {});
                const arrNumbers = Object.keys(obj).map(key => obj[key]);
                this.carousel.title = Object.keys(obj).find(key => obj[key] === Math.max(...arrNumbers)) ?? '';
            }
        },
        onSplideMove({ index }) {
            this.carousel.currentCarousel = index;
        },
        nextSlide() {
            this.$refs.date_splide.go('+1');
            this.getMonthTitle();
        },
        prevSlide() {
            this.$refs.date_splide.go('-1');
            this.getMonthTitle();
        },
        async getDateList() {
            if (!this.branch) return;

            this.dateList = [];
            this.carousel.currentCarousel = 0;
            this.isLoadingTime = true;
            let countDate = this.branch.consultations_date_limit;
            if (countDate && countDate > 0) {
                const arr = Array.from({ length: countDate }, (_, i) => {
                    let date = addDays(new Date(), i),
                        day = date.getDate(),
                        dayWeek = date.getDay(),
                        month = date.getMonth() + 1;
                    return {
                        day: day,
                        outlet: [0, 6].includes(dayWeek),
                        month: dateConfig.months[month],
                        dayWeek: dateConfig.weeks[dayWeek],
                        date: format(date, 'yyyy-MM-dd'),
                    }
                });

                const chunk = this.carousel.chunk;
                this.dateList = Array.from({ 
                    length: Math.ceil(arr.length / chunk) 
                }, (_, i) => arr.slice(i * chunk, i * chunk + chunk));
                this.getMonthTitle();
            }
            this.isLoadingTime = false;
        }
    },
    mounted () {
        this.onResize()
        window.addEventListener('resize', this.onResize, { passive: true })
    },
    unmounted () {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.onResize, { passive: true })
        }
    }
}
</script>

<style lang="scss" scoped>
.action-carousel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  h5 {
    font-family: 'Manrope Regular', serif;
    font-size: 18px;
    font-weight: 600;
  }

  button {
    background-color: transparent;
    border: 0;
    padding: 0;
    border-radius: 50%;
    color: #000;
    transition: all .1s ease-out;
  }

  button:hover:not(:disabled) {
    background-color: #DF413A;
    color: #fff;
    opacity: .8;
  }

  button:disabled {
    cursor: default;
    opacity: .3;
  }
}

.list-carousel {
  display: flex;
  justify-content: center;
  gap: 16px;
  
  .item-carousel.outlet-carousel {
    color: #DF413A;
  }
  .item-carousel.active-carousel {
    color: #fff;
    background-color: #DF413A;
  }
  .item-carousel.loading-carousel {
    opacity: .6;
  }
  .item-carousel {
    height: 90px;
    width: 100%;
    max-width: 70px;
    border: 1px solid rgb(225, 226, 226);
    border-radius: 12px;
    cursor: pointer;
    background-color: #fff;

    .item-title {
      height: 100%;
      flex-direction: column;
      display: flex;
      align-items: center;
      gap: 8px;
      padding-top: 10px;

      .item-title-week {
        font-weight: 500;
        font-size: 14px;
      }

      .item-title-day {
        font-size: 20px;
        font-weight: 500;
      }
    }

    h6 {
      margin: 0;
    }

    input[type="radio"] {
      position: absolute;
      opacity: 0;
    }
  }
}

@media (max-width: 768px) {
  .list-carousel {
    justify-content: space-between;
    gap: 0;
  }
}

.mobile-resize {
    justify-content: center;
    gap: 10px;
}
</style>